import { useRef, useEffect } from 'react';
import { DEFAULT_SCROLL_DELAY } from '../constants';
/**
 * Хук отвечает за автоскролл к заголовку последнего активного айтема, если тот
 * скрылся за пределы экрана при его открытии/закрытии.
 */
export const useAutoScrollToLastActive = _ref => {
  let {
    accordionItemsRef,
    scrollDelay = DEFAULT_SCROLL_DELAY
  } = _ref;
  const timer = useRef(null);
  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [timer]);
  const scrollToLastActive = lastActiveIndex => {
    timer.current = setTimeout(() => {
      const activeElement = accordionItemsRef.current[lastActiveIndex];
      const topPotision = activeElement.getBoundingClientRect().top;
      const isTopHidden = topPotision < 0;
      if (isTopHidden) {
        activeElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    }, scrollDelay);
  };
  return {
    scrollToLastActive
  };
};